// Live results being updated by Republic
const FLAT_RESULTS_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2026_primary/republic_json/results_FLAT.json';

// This has emptied out results i.e. is static
const STATIC_FLAT_RESULTS_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2026_primary/republic_json/results_FLAT_STATIC.json';

// This has the final certified results and is static
const FINAL_RESULTS_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2026_primary/republic_json/results_FLAT_FINAL_RESULTS.json';

// Includes fake results data for testing
const FAKE_RESULTS_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2026_primary/republic_json/results_FLAT_TEST.json';

const FAKE_RESULTS_URL_TWO =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2026_primary/republic_json/results_FLAT_AP_test.json';

const FAKE_RESULTS_MIDDLE =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2026_primary/republic_json/results_FLAT_AP_test_middle.json';

const FAKE_RESULTS_LATE =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2026_primary/republic_json/results_FLAT_AP_test_late_night.json';

const FAKE_RESULTS_LATE_2 =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2026_primary/republic_json/results_FLAT_COMPLETE_FEB_23_test.json';

// Used for homepage takeover
const HOMEPAGE_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2026_primary/homepage_takeover/2024-primary.json';

// Calls TT stories using the API
const STORY_API_URL = (id: number): string =>
  `https://www.texastribune.org/api/v2/articles/${id}/?format=json&fields=sitewide_image,summary,authors,url,pub_date,updated_date,homepage_headline`;

// This is for the other candidates for the hide/show toggle
const visibleCandidatesCount = 4;

// This is for the other candidates for the hide/show toggle just in the homepage
const visibleCandidatesCountHomepage = 2;

// Show bubble map toggle option. Set to false if we want to hide it.
const showBubbleMap = true;

// Show precincts or estimated votes still being counted text
const showPrecinctsReporting = true;

// Adds the checkmark if this is the final official results from local canvass
const isCanvass = false;

// Show last updated timestamp, set to true to last updated text
const showLastUpdated = false;

// What we are using across the ap
// will be used on the results page, in the homepage takeover
// and in the embeds
const RESULTS_IN_USE = FLAT_RESULTS_URL;

export {
  RESULTS_IN_USE,
  HOMEPAGE_URL,
  STORY_API_URL,
  visibleCandidatesCount,
  visibleCandidatesCountHomepage,
  showPrecinctsReporting,
  isCanvass,
  showLastUpdated,
  showBubbleMap,
};
